const GameStatus = {};

GameStatus.NONE = 0;
GameStatus.PRACTICE = 1;
GameStatus.RUNNING = 2;
GameStatus.TIMEOUT = 3;

export default GameStatus;